module.exports = __webpack_public_path__ + "static/img/Auction_On_phone.720cf55.png";